export default __webpack_public_path__ + "static/media/atm.fff1c74e.svg";